"use client"

import {useMemo} from "react"
import {useSharedUiTranslations, useUiControlLabels} from "@/components/i18n/ui-control-labels-context"
import {formatDayLabel, formatListTimestamp, formatClockTime, formatShortDate, formatFullDateTime} from "@/lib/conversation/time-format"

export function useConversationTimeFormatters() {
  const t = useSharedUiTranslations("ConversationTime")
  const {locale} = useUiControlLabels()
  return useMemo(() => ({
    formatDayLabel: (iso: string, timezone: string) => formatDayLabel(iso, timezone, t, locale),
    formatListTimestamp: (iso: string | null, timezone: string) => formatListTimestamp(iso, timezone, t, locale),
    formatClockTime: (iso: string, timezone: string) => formatClockTime(iso, timezone, locale),
    formatShortDate: (iso: string, timezone: string) => formatShortDate(iso, timezone, locale),
    formatFullDateTime: (iso: string, timezone: string) => formatFullDateTime(iso, timezone, locale),
  }), [t, locale])
}
